import { render, staticRenderFns } from "./modalSalario.vue?vue&type=template&id=4a3f299c&scoped=true&"
import script from "./modalSalario.vue?vue&type=script&lang=js&"
export * from "./modalSalario.vue?vue&type=script&lang=js&"
import style0 from "./modalSalario.vue?vue&type=style&index=0&id=4a3f299c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3f299c",
  null
  
)

export default component.exports